import { CLINIC, callLink, waLink } from "../data/clinic";
import { useLang } from "../i18n/LanguageContext";
import { MessageCircle, Phone, Instagram, MapPin } from "lucide-react";
import { NAV_HREFS } from "../data/clinic";

export default function Footer() {
  const { lang, t } = useLang();
  const f = t.footer;
  const NAV = [
    { label: t.nav.services, href: NAV_HREFS[0] },
    { label: t.nav.about, href: NAV_HREFS[1] },
    { label: t.nav.why, href: NAV_HREFS[2] },
    { label: t.nav.location, href: NAV_HREFS[3] },
    { label: t.nav.contact, href: NAV_HREFS[4] },
  ];

  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-brand-ink text-white">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-[1.5fr_1fr_1fr]">
          <div>
            <p className="font-display text-3xl leading-tight md:text-4xl">Kesari Dental Clinic</p>
            <p className="mt-1 text-sm uppercase tracking-[0.3em] text-brand-warm">{t.clinicShort} · BDS, MDS</p>
            <p className="mt-6 max-w-sm text-white/70 leading-relaxed">{f.tagline}</p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a href={waLink(null, lang)} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-btn" className="inline-flex items-center gap-2 rounded-full bg-brand-warm px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-brand-warmHover">
                <MessageCircle className="h-4 w-4" /> {t.common.book}
              </a>
              <a href={callLink} data-testid="footer-call-btn" className="inline-flex items-center gap-2 rounded-full border border-white/30 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-white/10">
                <Phone className="h-4 w-4" /> {CLINIC.phone}
              </a>
            </div>

            <div className="mt-8 flex items-center gap-4">
              <span className="text-xs font-semibold uppercase tracking-[0.25em] text-white/50">
                {t.common.followUs}
              </span>
              <a
                href={CLINIC.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-btn"
                aria-label={`${t.common.followInstagram} — ${CLINIC.instagramHandle}`}
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/30 text-white transition-colors hover:border-brand-warm hover:bg-brand-warm hover:text-white"
              >
                <Instagram className="h-4 w-4" strokeWidth={1.75} />
              </a>
              <a
                href={CLINIC.googleBusiness}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-google-btn"
                aria-label={`${t.common.viewOnGoogle} — ${CLINIC.name}`}
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/30 text-white transition-colors hover:border-brand-warm hover:bg-brand-warm hover:text-white"
              >
                <MapPin className="h-4 w-4" strokeWidth={1.75} />
              </a>
            </div>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-white/50">{f.quickLinks}</p>
            <ul className="mt-5 space-y-3">
              {NAV.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-white/80 transition-colors hover:text-brand-warm">{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-white/50">{f.visitHours}</p>
            <address className="mt-5 space-y-3 not-italic text-white/80">
              <p>{t.location.address}</p>
              <p>{f.hoursLine}</p>
              <p className="text-brand-warm">{f.emergencyLine}</p>
            </address>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-sm text-white/50 md:flex-row">
          <p>© {new Date().getFullYear()} Dr. Vinita&apos;s Kesari Dental Clinic, Hisar. {f.rights}</p>
          <p>{f.seoLine}</p>
        </div>
      </div>
    </footer>
  );
}
